import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120pcSchEService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Service Method Signature
  saveF1120pcSchEForm(
    baseUrl: string, 
    mainData: any[], 
    diagnosticData: any[],
    globalService: any, 
    filterParams: any = {}, 
    rowData: any = {}
  ): Observable<any> {
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Essential parameters with fallbacks - match AngularJS exactly
    params.jsonSettings = JSON.stringify({
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO,
      "jcd_key": rowData.JCD_KEY,
      "combination_key": rowData.COMBINATION_KEY,
      "trans_type_key": mainData[0].editrows[0][0].trans_type_key
    });
    params.jsonObj = JSON.stringify(mainData);
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = filterParams.process_name || "1120PC Sch E";  // Match AngularJS format
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = mainData[0].editrows[0][0].trans_type_key;
    
    // Include checkLockedbj from rowData (NOT hardcoded) - match AngularJS format exactly
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.LE_NAME,  // Use LEID like in AngularJS
      "me_code": rowData.ME,                    // Add me_code like in AngularJS
      "combination_key": rowData.COMBINATION_KEY
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // MUST use application/x-www-form-urlencoded (NOT application/json):
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/saveJsonObject?action_code=nkepph";

    // Save form data and diagnostic data in parallel
    const formSave$ = this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
    
    // Save diagnostic data
    if (diagnosticData && diagnosticData.length > 0) {
      const diagParams: any = {
        diag_exception: JSON.stringify(diagnosticData),
        tax_year: rowData.TAX_YEAR,
        screen_key: rowData.SCREEN_KEY || globalService?.globalParams?.screen_key || '',
        scenario: rowData.SCENARIO,
        jcd_key: rowData.JCD_KEY,
        scenarioCode: filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF",
        is_issue_key_enabled: "N"
      };

      const diagUrlEncoded = new URLSearchParams();
      Object.keys(diagParams).forEach(key => {
        if (diagParams[key] !== undefined && diagParams[key] !== null) {
          diagUrlEncoded.set(key, diagParams[key].toString());
        }
      });

      const diagUrl = baseUrl + "/saveJsonObject?action_code=ftmltp";
      
      // Execute diagnostic save in parallel (not blocking main save)
      this.http.post<any>(diagUrl, diagUrlEncoded.toString(), { headers, withCredentials: true })
        .subscribe({
          next: (diagResponse) => {
            console.log('Diagnostic data saved successfully:', diagResponse);
          },
          error: (diagError) => {
            console.error('Error saving diagnostic data:', diagError);
          }
        });
    }

    return formSave$;
  }
}
